import { GameSetup, GameState } from '../../../../types/types';
import {
  getGameStateFromSetup,
  Cardinal,
  tryMoveInDirection,
  isGameOver,
  areCoordinatesAdjacent,
  coordinateInDirection,
  getTileKey,
} from './PuzzleBuilderEngine';

export function getAllValidPathsForGame(gameSetup: GameSetup): GameState[] {
  const firstState = getGameStateFromSetup(gameSetup);
  const unfinishedQueue: GameState[] = [];
  const finished: GameState[] = [];

  //Initialise every possible start path
  for (const key in firstState.tiles) {
    const value = firstState.tiles[key];
    const setup = JSON.parse(JSON.stringify(gameSetup));
    const gameState = getGameStateFromSetup({
      ...setup,
      startCoordinates: { x: value.coordinates.x, y: value.coordinates.y },
    });
    unfinishedQueue.push(gameState);
  }

  while (unfinishedQueue.length > 0 && unfinishedQueue.length < 100) {
    const state = unfinishedQueue.pop();

    if (!state) {
      continue;
    }

    const directions = [
      Cardinal.North,
      Cardinal.East,
      Cardinal.West,
      Cardinal.South,
    ];

    directions.forEach((c) => {
      const result = tryMoveInDirection(state, c);

      if (state.path.length >= result.path.length) {
        return;
      } else if (isGameUnsolvable(result)) {
        return;
      } else if (isGameOver(result)) {
        finished.push(result);
        return;
      } else {
        unfinishedQueue.push(result);
        return;
      }
    });
  }

  return finished;
}

function isGameUnsolvable(gameState: GameState) {
  const tiles = Object.values(gameState.tiles);
  let countEnds = 0;

  for (const tile of tiles) {
    if (tile.guess !== undefined) {
      return;
    }

    const directions = [
      Cardinal.North,
      Cardinal.East,
      Cardinal.West,
      Cardinal.South,
    ];

    let countAdjacentFreeTiles = 0;

    if (
      areCoordinatesAdjacent(
        gameState.path[gameState.path.length - 1],
        tile.coordinates,
      )
    ) {
      countAdjacentFreeTiles++;
    }

    for (const d of directions) {
      const c = coordinateInDirection(tile.coordinates, d);
      const t = gameState.tiles[getTileKey(c)];
      if (t !== undefined && t.guess === undefined) {
        countAdjacentFreeTiles++;
        if (countAdjacentFreeTiles > 1) {
          break;
        }
      }
    }

    if (countAdjacentFreeTiles <= 1) {
      countEnds++;
      if (countEnds > 1) {
        return true;
      }
    }
  }
  return false;
}
